import { ButtonBase, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, HOVER_BG, LEVEL_TONE } from '../utils/constants';
import { fmtHours } from '../utils/hours';
import PersonAvatar from './PersonAvatar';

/** One person in the selected day's panel - face, name, hours and % that day; opens their drawer. */
export default function DayPersonButton({ row, onOpen }) {
  return (
    <ButtonBase
      onClick={() => onOpen(row.person.id)}
      sx={{ display: 'flex', gap: 1.25, justifyContent: 'flex-start', textAlign: 'left', borderRadius: 2, px: 0.75, py: 0.75, '&:hover': { bgcolor: HOVER_BG } }}
    >
      <PersonAvatar person={row.person} size={26} />
      <Typography noWrap sx={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: 500, color: WD.ink }}>{row.person.name}</Typography>
      <Typography sx={{ fontSize: 12, color: WD.inkFaint, ...FIGURE }}>{fmtHours(row.allocated)}</Typography>
      <Typography sx={{ width: 44, textAlign: 'right', fontSize: 12.5, fontWeight: 700, ...FIGURE, color: row.level === 'overloaded' ? LEVEL_TONE.overloaded.text : WD.ink }}>
        {Math.round(row.pct)}%
      </Typography>
    </ButtonBase>
  );
}
